import { HttpErrorResponse, HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router, RouterState } from '@angular/router';
import { environment } from '../../environments/environment';
import { EventService } from '../service/event.service';
import { ShowErrorEvent, ShowProgressEvent, SessionExpireEvent, FormSubmittedEvent, CountryMistmatchEvent, EmploymentGapEvent } from '../service/events';
import { Observable, tap } from 'rxjs';


@Injectable()
export class AuthInterceptor implements HttpInterceptor {

    constructor(private router: Router, private eventBus: EventService) {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (req.url.includes(environment.api_uri)) {
            if (!(req.url.includes("/uploadApplicantAttachments") || req.url.includes("/uploadApplicantDisputeAttachments") || req.url.includes("/getVendorBatchRequest"))) {
                this.eventBus.emit(new ShowProgressEvent({ show: true }));
            }
            req = req.clone({
                headers: this.setReqHeaders(req.headers)
            });

            this.eventBus.emit(new SessionExpireEvent({ text: "New Session" }));

            return next.handle(req).pipe(tap({
                next: (event: HttpEvent<any>) => {
                    if (event instanceof HttpResponse) {
                        if (event.body && event.body.submitFlag) {
                            this.eventBus.emit(new FormSubmittedEvent({ text: event.body.submitFlag }));
                        }
                        this.eventBus.emit(new ShowProgressEvent({ show: false }));
                        this.eventBus.emit(new ShowErrorEvent({ httpStatus: 0, text: '' }));
                        const x_auth_token: string = event.headers.get(environment.x_auth_token_header);
                        const x_verify_token: string = event.headers.get(environment.verify_token_header);
                        this.storeToken(environment.x_auth_token_header, x_auth_token);
                        this.storeToken(environment.verify_token_header, x_verify_token);
                    }
                },
                error: (err: any) => {
                    if (err instanceof HttpErrorResponse) {
                        this.eventBus.emit(new ShowProgressEvent({ show: false }));
                        if (!(req.url.includes("/uploadApplicantAttachments") || req.url.includes("/submitVendorBatchRequest"))) {
                            let errorText: any;

                            // Add check for ApplicationException with AFErrorCode else ApplicationException with Message
                            if (err.error instanceof String) {
                                errorText = err.error;
                            } else {
                                errorText = err.error.error;
                            }

                            if (errorText instanceof String && errorText.includes("AF-5")) {//server country mismatch error code
                                console.log("AuthInterceptor firing CountryMistmatchEvent");
                                this.eventBus.emit(new CountryMistmatchEvent({ show: true }));
                            } else if (errorText instanceof String && errorText.includes("AF-6")) {
                                this.eventBus.emit(new EmploymentGapEvent({ show: true }));
                            } else {
                                this.eventBus.emit(new ShowErrorEvent({ httpStatus: err.status, text: err.error }));
                            }
                        }

                        const state: RouterState = this.router.routerState;
                        console.log('return state url', state.snapshot.url);
                    }
                }
            }));
        }

        return next.handle(req);
    }

    storeToken(key: string, token: string): void {
        if (token && key) {
            sessionStorage.setItem(key, token);
        }
    }

    setReqHeaders(headers: HttpHeaders): HttpHeaders {
        let xToken = sessionStorage.getItem(environment.x_auth_token_header);
        let xVerifyId = sessionStorage.getItem(environment.verify_token_header);
        headers.set('Content-Type', 'applicantion/json');
        headers.set('Accept', 'application/json');
        if (xToken) {
            headers = headers.set(environment.x_auth_token_header, xToken);

        }
        if (xVerifyId) {
            headers = headers.set(environment.verify_token_header, xVerifyId);
        }
        return headers;
    }
}
